import type { Transaction } from "@rocicorp/zero";
import { canWriteSpace, type Context, userFacingError } from "../authorization";
import { type Schema, zql } from "../generatedDrizzleSchema";

// Write access to a chat: the caller's own personal chat, or a workflow chat
// in a space they can write.
export async function assertCanWriteChat(
  tx: Transaction<Schema>,
  ctx: Context,
  chatId: string
) {
  const [pc] = await tx.run(
    zql.personalChats.where("chatId", chatId).where("userId", ctx.userId)
  );
  if (pc) return;

  // NOTE: do not pass `{ scalar: true }` to these whereExists calls — the
  // zeroDrizzle server adapter mishandles nested scalar exists on the
  // tenant-grant path of canWriteSpace and silently returns no rows.
  const [workflowChat] = await tx.run(
    zql.chats
      .where("id", chatId)
      .whereExists("commit", (c) =>
        c.whereExists("branch", (b) =>
          b.whereExists("workflow", (w) =>
            w.whereExists("space", (s) => s.where(canWriteSpace(ctx)))
          )
        )
      )
  );
  if (workflowChat) return;

  throw userFacingError("Chat not found");
}
